export default {
  title: 'Rabatt für Jahresvertrag',
  buttons: {
    edit: 'Rabatt bearbeiten',
    save: 'Rabatt speichern',
  },
  toasts: {
    invalid_discount: 'Der Rabatt für den Jahresvertrag muss zwischen {{min}}% und {{max}}% liegen',
  },
};
